import React from "react";
import MainBanner from "../../components/MainComponents/MainBanner";
import HealthService from "../../components/ServiceComponents/HealthService";
import Footer from "../../components/MainComponents/Footer";
import {  bannerSpecImage, mainTitle, specBanners } from "../../config";

import SpecialitiesServices from "../../components/SpecailitiesComponents/SpecialitiesServices";
import { newSpecialities } from "../../utils/NewData";
import ContactHeader from "../../components/MainComponents/ContactHeader";

const SpecialitiesPage = () => {
  return (
    <div>
      <ContactHeader/>
      <MainBanner
        
        bannerTitle={mainTitle}
        banenrHeadline={"Explore Our Specialized Treatments"}
        showButton={false}
        mainBannerImages = {[specBanners.bannerOne,specBanners.bannerTwo,specBanners.bannerThree]}
        bannerDescription={
          "Personalized care and advanced treatments to meet your unique needs. Discover our specialties today."
        }
      />
      <SpecialitiesServices specailities = {newSpecialities}/>
      <Footer />
    </div>
  );
};

export default SpecialitiesPage;
